var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-file-input',{attrs:{"dense":_vm.dense,"disabled":_vm.disabled,"label":_vm.label,"prepend-icon":"","prepend-inner-icon":_vm.Icon,"readonly":_vm.readonly,"rules":_vm.Rules},model:{value:(_vm.file),callback:function ($$v) {_vm.file=$$v},expression:"file"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }